import { Box, Button, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormLabel, Grid, IconButton, Radio, RadioGroup } from "@material-ui/core"
import React from "react"
import CloseIcon from '@material-ui/icons/Close';
import { Edit } from "@material-ui/icons";
import { TestSequenceDialog } from "./TestSequenceDialog";
import { useAssignRSD } from "../../../dataEgress/dataEgressMutations";
import { useFetchContext } from "../../../common/FetchContext";
import { useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { set } from "lodash";
import { useSerialNumber } from "../../../testCommunication/common/testQueries";

export const DefineDataDialog = ({ report_data }: any) => {
  const { mutateAsync: mutateRsd } = useAssignRSD();
  const { authAxios } = useFetchContext();  
  const queryClient = useQueryClient()

    const [open, setOpen] = React.useState(false);
    const [openCustomeDialog, setOpenCustomeDialog] = React.useState(false);
    const [openTsDialog, setOpenTsDialog] = React.useState(false);
    const [openConfirmDialog, setOpenConfirmDialog] = React.useState(false);

    const [value, setValue] = React.useState("");
    const {
        error: errorUnits,
        data: serialNumberData,
        isError: isErrorUnits,
        isSuccess: isSuccessUnits,
        isLoading: isLoadingUnits,
    } = useSerialNumber(report_data.work_order_id);
   

    const handleChange = (e: { target: { value: React.SetStateAction<string>; }; }) => {
        setValue(e.target.value);
        console.log("Selected:", e.target.value);
    };

    const handleClose = () => {
        // if(report_data.data_ready_status==='Define'||report_data.data_ready_status===""){   
        //     setOpen(!open);
        // }
        setOpen(!open);


    };

    const confirmCustomDialogEvent = async () => {

        try {
                  
            await mutateRsd({
              authAxios,
              report_result_id:report_data.Id,
              data_ready_status:value,
            });
            setOpen(false);
            setOpenCustomeDialog(false);
            setOpenConfirmDialog(false);
      
            toast.success("Report was succesfully changed");

           
          } catch (error) {
            toast.error(`Error updating: ${error}`);
          }finally{
             queryClient.invalidateQueries(["report_result_data", report_data.work_order_id]);
       
         }
    };

    const closeTsdDialog = () => {
        setOpen(false);
        setOpenTsDialog(!openTsDialog);
    };

    const disMissConfirmDialog = () => {
        setOpenConfirmDialog(!openConfirmDialog);
    };
    const handleCloseCustomDialog = () => {
        setOpen(false);
        setOpenCustomeDialog(!openCustomeDialog);
    };
 

    return (
        <>
            <label onClick={handleClose} style={{ cursor: "pointer", color:report_data.hex_color }}>{report_data.data_ready_statuss?report_data.data_ready_statuss:"Define"}</label>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={false}>
                <DialogTitle id="id">
                    <div>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1} >Define Data Readiness</Box>
                            <Box>
                                <IconButton onClick={handleClose}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>

                    </div>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={3}>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => { setOpenCustomeDialog(!openCustomeDialog),setOpen(!open) }}
                            >
                                CUSTOM DEFINITION
                            </Button>
                        </Grid>
                        <Grid item xs={12}>
                            <Button
                                variant="contained"
                                color="primary"
                                fullWidth
                                onClick={() => { setOpenTsDialog(true),setOpen(false) }}
                            >
                                TEST DEFINITION
                            </Button>
                        </Grid>
                    </Grid>

                </DialogContent>

                <DialogActions>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openCustomeDialog}
                onClose={handleCloseCustomDialog}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={false}>
                <DialogTitle id="id">
                    <div>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1} >Choose Event Type</Box>
                            <Box>
                                <IconButton onClick={handleCloseCustomDialog}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>

                    </div>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={1}>
                        <FormControl>
                            <FormLabel>Select an Option</FormLabel>

                            <RadioGroup value={value} onChange={handleChange}>
                                <FormControlLabel value="Module Intake" control={<Radio />} label="Module Intake" />
                                <FormControlLabel value="Factory witness" control={<Radio />} label="Factory witness" />
                            </RadioGroup>

                        </FormControl>

                    </Grid>

                </DialogContent>

                <DialogActions>
                    <Button  onClick={() => { 
                          if(value!=''){
                            setOpenConfirmDialog(true)

                          }else{
                              toast.success("Please select an option");
                  
                          }
                         }}>Confirm</Button>
                </DialogActions>
            </Dialog>

            <Dialog
                open={openTsDialog}
                onClose={closeTsdDialog}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={true}>
                <DialogTitle id="id">
                    <div>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1} >Choose Serial Number</Box>
                            <Box>
                                <IconButton onClick={closeTsdDialog}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>

                    </div>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={1}>

                        <TestSequenceDialog serialNumberData={serialNumberData} report_result={report_data}  />
                    </Grid>

                </DialogContent>

            </Dialog>


            <Dialog
                open={openConfirmDialog}
                onClose={disMissConfirmDialog}
                aria-labelledby="scroll-dialog-title"
                aria-describedby="scroll-dialog-description"
                fullWidth={true}>
                <DialogTitle id="id">
                    <div>
                        <Box display="flex" alignItems="center">
                            <Box flexGrow={1} >Confirm</Box>
                            <Box>
                                <IconButton onClick={disMissConfirmDialog}>
                                    <CloseIcon />
                                </IconButton>
                            </Box>
                        </Box>

                    </div>
                </DialogTitle>

                <DialogContent>
                    <Grid container spacing={1}>
                    <FormControl>
                            <FormLabel>Do you want to change status?</FormLabel>
                        </FormControl>
                    </Grid>

                </DialogContent>
                <DialogActions>
                    <Button onClick={confirmCustomDialogEvent}>Yes</Button>
                    <Button onClick={disMissConfirmDialog}>No</Button>
                </DialogActions>
            </Dialog>
        </>
    )
}